import fetch from 'isomorphic-fetch';
import Config from '../../config/';
import { detect } from 'detect-browser';
const browser = detect();

 const API = {
 	data: {
 		async getAll(obj) {
 			let response = await fetch(`${Config.api}/api/flowapplicantdetail/${JSON.stringify(obj)}`);

 			const status = response.status;
 			let data = await response.json();
 			return {
 				data:data.response,
 				status: status
 			};
 		},
	    async validateFlow(flow) {
	      const response = await fetch(`/api/flowadmindetailvalitadateflow`, {
	        method: 'POST',
	        headers: new Headers({
	          'Content-Type': 'application/json',
	          Accept: 'application/json',
	          Pragma: 'no-cache'
	        }),
	        body: JSON.stringify(flow)
	      });
	      const status = response.status;
	      const data = await response.json();
	      return { data: data, status: status };
	    },
	    async createFlow(flow) {
	      if(flow.flowRequest["mopPermitFilesNew"]) {
		      const fullPath = 
		      	document.getElementById(flow.flowRequest["mopPermitFilesNew"]).files;
		      if(fullPath) {
		      	flow.flowRequest["mopPermitFiles"] = "";
		      	for(var i=0;i<fullPath.length;i++) {		      		
      				var formData = new FormData();
	      			formData.append('file', fullPath[i]);
				  	var responseFile = await fetch(`/api/flowadmindetailuploadmopfile`, {
						method: 'POST',
						body: formData,
						headers: new Headers({
						  Pragma: 'no-cache'
						})
					});
					var statusFile = responseFile.status;
					var dataFile = await responseFile.json();
					if(statusFile!=200) {
						return { data: dataFile, status: statusFile };
					}
					else {
						flow.flowRequest["mopPermitFiles"] = 
							flow.flowRequest["mopPermitFiles"] + dataFile.response.filePath + "|";
					}
					
		      	}
		      }
	      }

	      const response = await fetch(`/api/flowapplicantdetail`, {
	        method: 'POST',
	        headers: new Headers({
	          'Content-Type': 'application/json',
	          Accept: 'application/json',
	          Pragma: 'no-cache'
	        }),
	        body: JSON.stringify(flow)
	      });
	      const status = response.status;
	      const data = await response.json();
	      return { data: data, status: status };
	    },
	    async updateFlow(flow) {
	      if(flow.flowRequest["mopPermitFilesNew"]) {
		      const fullPath = 
		      	document.getElementById(flow.flowRequest["mopPermitFilesNew"]).files;
		      if(fullPath) {
		      	flow.flowRequest["mopPermitFiles"] = "";
		      	for(var i=0;i<fullPath.length;i++) {		      		
      				var formData = new FormData();
	      			formData.append('file', fullPath[i]);
				  	var responseFile = await fetch(`/api/flowadmindetailuploadmopfile`, {
						method: 'POST',
						body: formData,
						headers: new Headers({
						  Pragma: 'no-cache'
						})
					});
					var statusFile = responseFile.status;
					var dataFile = await responseFile.json();
					if(statusFile!=200) {
						return { data: dataFile, status: statusFile };
					}
					else {
						flow.flowRequest["mopPermitFiles"] = 
							flow.flowRequest["mopPermitFiles"] + dataFile.response.filePath + "|";
					}
					
		      	}
		      }
	      }

	      const response = await fetch(`/api/flowapplicantdetail`, {
	        method: 'PUT',
	        headers: new Headers({
	          'Content-Type': 'application/json',
	          Accept: 'application/json',
	          Pragma: 'no-cache'
	        }),
	        body: JSON.stringify(flow)
	      });
	      const status = response.status;
	      const data = await response.json();
	      return { data: data, status: status };
	    },
	    async sendFlows(flows) {
	      const response = await fetch(`/api/flowapplicantdetailsendflows`, {
	        method: 'POST',
	        headers: new Headers({
	          'Content-Type': 'application/json',
	          Accept: 'application/json',
	          Pragma: 'no-cache'
	        }),
	        body: JSON.stringify(flows)
	      });
	      const status = response.status;
	      const data = await response.json();
	      return { data: data, status: status };
	    },
 		async handleDownloadMopFile(obj) {
	      let response = await fetch(`${Config.api}/api/flowadmindetailuploadmopfile/${encodeURIComponent(JSON.stringify(obj))}`, {
	        method: 'GET',
	        'Content-Type': 'blob',
	        headers: new Headers({ Pragma: 'no-cache' })
	      });
	      const status = response.status;	      

		  if(status==200) {
		  	  var filePathArray = obj.path.split("/");
	          var nameFile = filePathArray[filePathArray.length-1];
	          var fileNameArray = nameFile.split("_",2);
	          nameFile = fileNameArray[fileNameArray.length-1];
	      	  
	      	  const blob = await response.blob();
		  	  var a = document.createElement('a');
		      if (browser.name == 'ie') {
		        window.navigator.msSaveBlob(blob, nameFile);
		      } else {
		        a.setAttribute('href', window.URL.createObjectURL(blob));
		        a.setAttribute('target', '_blank');
		        a.setAttribute('download', nameFile);
		        a.style.display = 'none';
		        document.body.appendChild(a);
		        a.click();
		        document.body.removeChild(a);
		      }
		  }

	      return {
	        data: 'ok',
	        status: status
	      };
	    },
 	},
 };
 export default API;


// WEBPACK FOOTER //
// ./source/client/actions/flow_applicant_detail/api/index.js